<template>
  <div class="clinicservicedetail">
    <b-container fluid>
      <b-row class="mycontainer-main">
        <b-col
          cols="12"
          md="4"
          class="pl-5 leftcontent"
          :style="{
            backgroundImage:
              'linear-gradient(rgba(0, 0, 0, 0.5),rgba(0, 0, 0, 0.3)), url(' +
              this.img +
              ')',
          }"
        >
          <h1>{{ giftc_detail.name }}</h1>
          <b-button
            squared
            variant="outline-light"
            class="mt-3"
            @click="goBack"
          >
            {{ $t("common.home") }}
          </b-button>
          <appt-button v-bind:color="'l'" />
        </b-col>

        <b-col cols="12" md="6" class="align-center" v-if="giftc_detail">
          <div class="p-3">
            <h3>{{ giftc_detail.name }}</h3>
            <p style="color: black" v-html="giftc_detail.description"></p>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
const endata = [
  {
    name: "Classic Facial",
    slug: "classique",
    img: "gc_classic.png",
    description: `
    <p>You have received a wonderful gift, someone you love has chosen the classic facial treatment for you, it is our treatment par excellence.<p/>
    <br/>
    <p>This includes all the steps of the treatment, such as the welcome massage, aromatherapy, exfoliation of the skin, extraction of blackheads, massage of the feet, hands, neck , shoulders and scalp. It ends with the application of a mask and a period of relaxation.
    <p/>
    <br/>This treatment is mainly recognized for its moisturizing properties for the skin. This treatment lasts 1 hour 45 minutes.
    We look forward to welcoming you and taking care of you! </p>
    `,
  },
  {
    name: "Personalized Facial",
    slug: "personnalise",
    img: "gc_personalized.png",
    description: `
<p>You have received a wonderful gift, someone you love has chosen a personalized facial treatment for you, it is a treatment that is adapted to the needs of your skin.
</p><br/><p>This includes all stages of the treatment, such as the welcome massage, aromatherapy, exfoliation of the skin, extraction of black heads, foot massage , hands, neck, shoulders and scalp. It ends with the application of essence concentrates and a mask personalized to the needs of your skin, followed by a period of relaxation. 
</p><br/><p>This treatment is mainly recognized for being adapted to the needs of your skin, whether it is sensitive, dehydrated or lacking in radiance. This treatment lasts 1 hour 45 minutes.
</p><br/><p>We look forward to seeing you and taking care of you! <p/>
`,
  },
  {
    name: "Specific facial treatment",
    slug: "specifique",
    img: "gc_specific.png",
    description: `
<p>You have received a wonderful gift, someone you love has chosen the specific facial treatment for you, it is our most advanced treatment.
</p><br/><p>This includes all stages of the treatment, such as the welcome massage, aromatherapy, exfoliation of the skin, extraction of black heads, foot massage , hands, neck, shoulders and scalp. It ends with the application of essence concentrates and a mask personalized to the needs of your skin and a period of relaxation. This treatment is mainly recommended for skin that has a great need to regain radiance, anti-aging or for increased redness. This treatment lasts 1 hour 45 minutes.
</p><br/><p>We look forward to seeing you and taking care of you! <p/>
`,
  },
  {
    name: "Teen Care",
    slug: "ado",
    image: "gc_teen.png",
    description: `
<p>You have received a wonderful gift, someone you love has chosen for you the teenage facial treatment, it is our treatment designed for young skin.
</p><br/><p>This includes all the steps of the treatment, the exfoliation of the skin, the extraction of black heads and the touch relaxation techniques. It ends with the application of a mask personalized to the needs of the skin of an adolescent and a period of relaxation. This treatment is mainly recognized for skins that have a great need for purification and soothing. This treatment lasts 1 hour and 15 minutes.
</p><br/><p>We look forward to seeing you and taking care of you! <p/>
`,
  },
  {
    name: "Microdermabrasion",
    slug: "microdermabrasion",
    img: "gc_microdermabrasion.png",
    description: `<p>Recommended at each change of season, this complete cleaning treatment is designed to work the entire face down to the smallest corners.
    </p><br/><p>With the corundum sandblasting technique, the skin will be freed of its impurities, regenerated and renewed.<p/>`,
  },
  {
    name: "Eye Care",
    slug: "yeux",
    image: "gc_eyes.png",
    description: `<p>Eye care consists of the addition of a specific mask with active ingredients essentially designed for the eye contour.
    </p><br><p>The result is smoothing of the eye contour, soothing and brightening of the eye contour.<p/> `,
  },
  {
    name: "The Peeling",
    slug: "peeling",
    img: "gc_peeling.png",
    description: `<p>The peeling is a deep exfoliation activated by specific enzymes and chosen by our beauticians according to your skin. It provides a feeling of purity, radiance and an overall lightening of the complexion.<p/> `,
  },
  {
    name: "Neck care",
    slug: "cou",
    image: "gc_neck.png",
    description: `<p>The addition of the neck treatment is a specific mask applied to the neck.
    </p><br><p>This will help to restore suppleness and hydration to the skin of the neck weakened.<p/> `,
  },
  {
    name: "Currency Value",
    slug: "valeur-monetaire",
    image: "gc_monetary.png",
    description: `<p>You have received a wonderful gift, someone you love has chosen a monetary value for you to spend at Beauté Intégrale!
</p><br/><p>You will be spoiled for choice through our unique facial treatments, skin rejuvenation and revitalization technologies, permanent and/or traditional hair removal. 
</p><br/><p>You can also choose from a variety of professional skincare products, always with the advice and expertise of our certified beauticians.
</p><br/><p>We look forward to welcoming you and taking care of you!</p>`,
  },
];

const frdata = [
  {
    name: "Soin du visage classique",
    slug: "classique",
    img: "gc_classic.png",
    description: `
    <p>Vous avez reçu un merveilleux cadeau, une personne que vous aimez a choisi pour vous le soin du visage classique, c’est notre soin par excellence.<p/> 
    <br/>
    <p>Celui-ci comprend toutes les étapes du soin, telles que le massage de bienvenue, l’aromathérapie, l’exfoliation de la peau du visage, l’extraction des comédons, le massage des pieds, des mains, de la nuque, des épaules et du cuir chevelu. Il se termine par l’application d’un masque et d’une période de relaxation. 
    </p>
    <br/>Ce soin est principalement reconnu pour ses vertues hydratantes de la peau. Ce soin est d’une durée d’1h45 min.
    Nous avons très hâte de vous recevoir et prendre soin de vous! </p>
    `,
  },
  {
    name: "Soin du visage personnalisé",
    slug: "personnalise",
    img: "gc_personalized.png",
    description: `
<p>Vous avez reçu un merveilleux cadeau, une personne que vous aimez a choisi pour vous le soin du visage personnalisé, c’est un soin qui est adapté aux besoins de votre peau. 
</p><br/><p>Celui-ci comprend toutes les étapes du soin, telles que le massage de bienvenue, l’aromathérapie, l’exfoliation de la peau du visage, l’extraction des comédons, le massage des pieds, des mains, de la nuque, des épaules et du cuir chevelu. 
Il se termine par l’application de concentrés d’essences et d’un masque personnalisé aux besoins de votre peau, suivi d’une période de relaxation. 
</p><br/><p>Ce soin est principalement reconnu pour être adapté aux besoins de votre peau, qu’elle soit sensible, déshydratée ou en manque d’éclat. Ce soin est d’une durée d’1h45 min.
</p><br/><p>Nous avons très hâte de vous recevoir et prendre soin de vous! <p/>
`,
  },
  {
    name: "Soin du visage spécifique",
    slug: "specifique",
    img: "gc_specific.png",
    description: `
<p>Vous avez reçu un merveilleux cadeau, une personne que vous aimez a choisi pour vous le soin du visage spécifique, c’est notre soin le plus avancé. 
</p><br/><p>Celui-ci comprend toutes les étapes du soin, telles que le massage de bienvenue, l’aromathérapie, l’exfoliation de la peau du visage, l’extraction des comédons, le massage des pieds, des mains, de la nuque, des épaules et du cuir chevelu. Il se termine par l’application de concentrés d’essences et d’un masque personnalisé aux besoins de votre peau et d’une période de relaxation. Ce soin est principalement recommandé pour les peaux qui ont un grand besoin de retrouver éclat, l’anti-âge ou pour des rougeurs accrues. Ce soin est d’une durée d’1h45 min.
</p><br/><p>Nous avons très hâte de vous recevoir et prendre soin de vous! <p/>
`,
  },
  {
    name: "Soin ado",
    slug: "ado",
    img: "gc_teen.png",
    description: `
<p>Vous avez reçu un merveilleux cadeau, une personne que vous aimez a choisi pour vous le soin du visage ado, c’est notre soin conçu pour les jeunes peaux.
</p><br/><p>Celui-ci comprend toutes les étapes du soin, l’exfoliation de la peau du visage, l’extraction des comédons et les techniques d’effleurement de relaxation. Il se termine par l’application de masque personnalisé aux besoins de la peau d’un(e) adolescent(e) et d’une période de relaxation. Ce soin est principalement reconnu pour les peaux qui ont un grand besoin de puritfication et d’apaisement. Ce soin est d’une durée d’1h15 min.
</p><br/><p>Nous avons très hâte de vous recevoir et prendre soin de vous! <p/>
`,
  },
  {
    name: "La microdermabrasion",
    slug: "microdermabrasion",
    img: "gc_microdermabrasion.png",
    description: `<p>Recommandée à chaque changement de saison, ce soin “Grand ménage” complet est conçu pour travailler l’ensemble du visage jusque dans les plus petits racoins. 
    </p><br/><p>Grâce à la technique du sablage au corindon, la peau se trouvera libérée de ses impuretés, régénérée et renouvelée.<p/>`,
  },
  {
    name: "Le soin des yeux",
    slug: "yeux",
    img: "gc_eyes.png",
    description: `<p>Le soin des yeux consiste à l’ajout d’un masque spécifique aux actifs essentiellement conçus pour le contour des yeux. 
    </p><br><p>Il en résulte du défroissement du contour des yeux, de l’apaisement et de l’éclaircissement du regard.<p/> `,
  },
  {
    name: "Le peeling",
    slug: "peeling",
    img: "gc_peeling.png",
    description: `<p>Le peeling est une exfoliation en profondeur activée par des enzymes spécifiques et choisies par notre esthéticiennes en fonction de votre peau. Il procure une sensation de pureté, d’éclat et d’un éclaircissement du teint en général.<p/> `,
  },
  {
    name: "Le soin du cou/décolleté",
    slug: "cou",
    img: "gc_neck.png",
    description: `<p>L’ajout du soin du cou/décolleté est un masque spécifique appliqué au niveau du cou et du décolleté. 
    </p><br><p>Celui-ci aidera à redonner souplesse et hydratation à la peau du cou et du décolleté fragilisée.<p/>  `,
  },
  {
    name: "Valeur monétaire",
    slug: "valeur-monetaire",
    img: "gc_monetary.png",
    description: `
<p>Vous avez reçu un merveilleux cadeau, une personne que vous aimez a choisi pour vous une valeur monétaire à dépenser chez Beauté Intégrale! 
<p/><br><p>Vous aurez l’embarras du choix à travers nos soins du visages uniques, technologies de rajeunissement et ravivement de la peau, d’épilation définitive et/ou traditionnelle. 
<p/><br><p>Vous pouvez aussi choisir à travers une variété de produits professionnels de la peau, toujours avec les conseils et l’expertise de nos esthéticiennes certifiées.
<p/><br><p>Nous avons très hâte de vous recevoir et prendre soin de vous!<p/>
`,
  },
];

export default {
  name: "giftcardDetail",
  //   prop: ["service-name"],
  data() {
    return {
      giftc_detail: "",
      giftc_detail_list: "",
      img: "",
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    getData() {
      if (this.$i18n.locale == "fr") {
        this.giftc_detail_list = frdata;
      } else this.giftc_detail_list = endata;

      var x = this.giftc_detail_list.filter(
        (item) => item.slug === this.giftc_slug
      );
      if (x.length > 0) {
        this.giftc_detail = x[0];
      } else {
        this.$router.push({ name: "Main" });
      }
    },
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    },
    giftc_slug() {
      return this.$route.params.slug;
    },
  },
  mounted() {
    this.getData();
    if (this.giftc_detail) {
      this.img = require("../assets/images/giftc/" + this.giftc_detail.img);
    }
  },
  watch: {
    locale: function (newLocale, oldLocale) {
      this.getData();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.mycontainer-main {
  min-height: 90vh;
}
.leftcontent {
  color: white;
  padding-top: 30vh;
  padding-bottom: 10vh;
  /* background-image: linear-gradient(rgba(0, 0, 0, 0.5),
                       rgba(0, 0, 0, 0.3)), url('../assets/images/retail-clinic.jpg'); */
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}
/* .card-columns {
    column-count: 2;
} */
/* @media (max-width: 576px) {
    .card-columns {
        column-count: 1;
    }
} */
.card {
  margin: 5px 0 5px 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/GiftCardDetail.vue